<template>
  <path
    d="M5.75 10C6.16421 10 6.5 10.3358 6.5 10.75C6.5 11.1642 6.16421 11.5 5.75 11.5C5.33579 11.5 5 11.1642 5 10.75C5 10.3358 5.33579 10 5.75 10Z"
    fill="currentColor"
  />
  <path
    d="M5.75 4.5C6.16421 4.5 6.5 4.83579 6.5 5.25C6.5 5.66421 6.16421 6 5.75 6C5.33579 6 5 5.66421 5 5.25C5 4.83579 5.33579 4.5 5.75 4.5Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.25 2C13.2165 2 14 2.7835 14 3.75V12.25C14 13.2165 13.2165 14 12.25 14H3.75C2.7835 14 2 13.2165 2 12.25V3.75C2 2.7835 2.7835 2 3.75 2H12.25ZM3.5 12.25C3.5 12.3881 3.61193 12.5 3.75 12.5H12.25C12.3881 12.5 12.5 12.3881 12.5 12.25V8.75H3.5V12.25ZM3.75 3.5C3.61193 3.5 3.5 3.61193 3.5 3.75V7.25H12.5V3.75C12.5 3.61193 12.3881 3.5 12.25 3.5H3.75Z"
    fill="currentColor"
  />
</template>
